const AUTH_BASE_PATH_KEY = 'vmvpd_auth_base_path';

export type AuthBasePath = '/auth' | '/device-auth';

export const setAuthBasePath = (basePath: AuthBasePath): void => {
  try {
    sessionStorage.setItem(AUTH_BASE_PATH_KEY, basePath);
  } catch (error) {
    console.error('Erro ao definir basePath:', error);
  }
};

export const getAuthBasePath = (): AuthBasePath => {
  try {
    return (sessionStorage.getItem(AUTH_BASE_PATH_KEY) as AuthBasePath) || '/auth';
  } catch (error) {
    console.error('Erro ao obter basePath:', error);
    return '/auth';
  }
};

export const clearAuthBasePath = (): void => {
  try {
    sessionStorage.removeItem(AUTH_BASE_PATH_KEY);
  } catch (error) {
    console.error('Erro ao limpar basePath:', error);
  }
};


